import { UPDATE_CATEGORY } from '../../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case UPDATE_CATEGORY.LOAD:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_CATEGORY.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case UPDATE_CATEGORY.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
